export enum EColors {
  black = '#000000',
  white = '#ffffff',
  red = '#E04E4E',

  neutral_100 = '#F8F8F8', 
  neutral_200 = '#DFDFDF',
  neutral_300 = '#CACACA',
  neutral_400 = '#B5B5B5',
  neutral_500 = '#A0A0A0',
  neutral_600 = '#333333',
  neutral_700 = '#181817',

  primary_100 = '#F8C699',
  primary_200 = '#EF7F1A',

  accent_100 = '#B5FED7',
  accent_200 = '#25BF6C',
  accent_300 = '#009846',
  accent_400 = '#057639',

  bg_dark = '#181817',
  bg_light = '#F8F8F8',
 
}
